//update along with app/lib/enums/user_time_log_enums.py
const UserTimeLogActivityType = {
  BRAND_CONTENT_QA: 'BRAND_CONTENT_QA',
  CHENEY_CATALOG_ENRICHMENT: 'CHENEY_CATALOG_ENRICHMENT',
  CLASSIFICATION: 'CLASSIFICATION',
  CLASSIFICATION_QA: 'CLASSIFICATION_QA',
  DEFAULT_L4_IMAGES: 'DEFAULT_L4_IMAGES',
  DP_SALES_PORTAL_ENRICHMENT: 'DP_SALES_PORTAL_ENRICHMENT',
  ENRICH_UPB: 'ENRICH_UPB',
  LINK_VERIFICATION_GPL: 'LINK_VERIFICATION_GPL',
  LINK_VERIFICATION_SPL: 'LINK_VERIFICATION_SPL',
  LINK_VERIFICATION_QA: 'LINK_VERIFICATION_QA',
  MEETINGS: 'MEETINGS',
  MFR_PORTAL_CREATION: 'MFR_PORTAL_CREATION',
  QA_BRANDS: 'QA_BRANDS',
  SUPPORT_TICKETS: 'SUPPORT_TICKETS',
  TAXONOMY_AUDITING_SHUFFLING: 'TAXONOMY_AUDITING_SHUFFLING',
  TRAININGS: 'TRAININGS',
  VERIFY_SIMILAR_BRAND_NAMES: 'VERIFY_SIMILAR_BRAND_NAMES',
  NEW_DP_ENRICHMENT: 'NEW_DP_ENRICHMENT',
  DP_MAINTENANCE: 'DP_MAINTENANCE',
  DP_ENRICHMENT_QA: 'DP_ENRICHMENT_QA',
  AD_LAUNCH_WORK: 'AD_LAUNCH_WORK',
  QUICK_BOOKS_UPDATE: 'QUICK_BOOKS_UPDATE',
  MFR_CATALOG_CLEANUP: 'MFR_CATALOG_CLEANUP',
  MFR_SKU_CLEANUP: 'MFR_SKU_CLEANUP',
  DP_ENRICHMENT_QA_AI_SUGGESTED: 'DP_ENRICHMENT_QA_AI_SUGGESTED',
  DP_ENRICHMENT_QA_AI_SUGGESTED_TRAINING: 'DP_ENRICHMENT_QA_AI_SUGGESTED_TRAINING',
  BRAND_CLEANUP: 'BRAND_CLEANUP',
  BRAND_CLEANUP_TRAINING: 'BRAND_CLEANUP_TRAINING',
  DUPLICATE_BRAND_CLEANUP: 'DUPLICATE_BRAND_CLEANUP',
  DUPLICATE_BRAND_CLEANUP_TRAINING: 'DUPLICATE_BRAND_CLEANUP_TRAINING',
};

const UserTimeLogActivityTypeDisplayOptions = {
  [UserTimeLogActivityType.BRAND_CONTENT_QA]: 'Brand Content QA',
  [UserTimeLogActivityType.CHENEY_CATALOG_ENRICHMENT]: 'Cheney Catalog Enrichment',
  [UserTimeLogActivityType.CLASSIFICATION]: 'Classification',
  [UserTimeLogActivityType.CLASSIFICATION_QA]: 'Classification QA',
  [UserTimeLogActivityType.DEFAULT_L4_IMAGES]: 'Default L4 Images',
  [UserTimeLogActivityType.DP_SALES_PORTAL_ENRICHMENT]: 'DP Sales Portal Enrichment',
  [UserTimeLogActivityType.ENRICH_UPB]: 'Enrich UPB',
  [UserTimeLogActivityType.LINK_VERIFICATION_GPL]: 'Link Verification GPL',
  [UserTimeLogActivityType.LINK_VERIFICATION_SPL]: 'Link Verification SPL',
  [UserTimeLogActivityType.LINK_VERIFICATION_QA]: 'Link Verification QA',
  [UserTimeLogActivityType.MEETINGS]: 'Meetings',
  [UserTimeLogActivityType.MFR_PORTAL_CREATION]: 'Mfr Portal Creation',
  [UserTimeLogActivityType.QA_BRANDS]: 'QA Brands',
  [UserTimeLogActivityType.SUPPORT_TICKETS]: 'Support Tickets',
  [UserTimeLogActivityType.TAXONOMY_AUDITING_SHUFFLING]: 'Taxonomy Auditing & Shuffling',
  [UserTimeLogActivityType.TRAININGS]: 'Trainings',
  [UserTimeLogActivityType.VERIFY_SIMILAR_BRAND_NAMES]: 'Verify Similar Brand Names',
  [UserTimeLogActivityType.NEW_DP_ENRICHMENT]: 'New DP Enrichment',
  [UserTimeLogActivityType.DP_MAINTENANCE]: 'DP Maintenance',
  [UserTimeLogActivityType.DP_ENRICHMENT_QA]: 'DP Enrichment QA',
  [UserTimeLogActivityType.AD_LAUNCH_WORK]: 'Ad Launch Work',
  [UserTimeLogActivityType.QUICK_BOOKS_UPDATE]: 'Quickbooks Update',
  [UserTimeLogActivityType.MFR_CATALOG_CLEANUP]: 'MFR: Catalog Cleanup',
  [UserTimeLogActivityType.MFR_SKU_CLEANUP]: 'MFR: SKU Cleanup',
  [UserTimeLogActivityType.DP_ENRICHMENT_QA_AI_SUGGESTED]: 'DP Enrichment QA (AI Suggested)',
  [UserTimeLogActivityType.DP_ENRICHMENT_QA_AI_SUGGESTED_TRAINING]:
    'DP Enrichment QA (AI Suggested -Training)',
  [UserTimeLogActivityType.BRAND_CLEANUP]: 'Brand Cleanup',
  [UserTimeLogActivityType.BRAND_CLEANUP_TRAINING]: 'Brand Cleanup (Training)',
  [UserTimeLogActivityType.DUPLICATE_BRAND_CLEANUP]: 'Duplicate Brand Cleanup',
  [UserTimeLogActivityType.DUPLICATE_BRAND_CLEANUP_TRAINING]: 'Duplicate Brand Cleanup (Training)',
};

const outputRequiredForActivityType = [
  UserTimeLogActivityType.AD_LAUNCH_WORK,
  UserTimeLogActivityType.CHENEY_CATALOG_ENRICHMENT,
  UserTimeLogActivityType.MFR_CATALOG_CLEANUP,
  UserTimeLogActivityType.MFR_SKU_CLEANUP,
  UserTimeLogActivityType.CLASSIFICATION_QA,
  UserTimeLogActivityType.DP_ENRICHMENT_QA,
  UserTimeLogActivityType.SUPPORT_TICKETS,
  UserTimeLogActivityType.TAXONOMY_AUDITING_SHUFFLING,
  UserTimeLogActivityType.QUICK_BOOKS_UPDATE,
  UserTimeLogActivityType.BRAND_CONTENT_QA,
];

const UserTimeLogActivityTypeOptions = Object.entries(UserTimeLogActivityType).map(
  ([key, value]) => ({
    label: UserTimeLogActivityTypeDisplayOptions[key],
    value: value,
  }),
);

export {
  UserTimeLogActivityType,
  UserTimeLogActivityTypeDisplayOptions,
  UserTimeLogActivityTypeOptions,
  outputRequiredForActivityType,
};
